export const F2F_STATUS_FETCH = 'F2F_STATUS_FETCH';
export const F2F_STATUS_FETCH_SUCCESS = 'F2F_STATUS_FETCH_SUCCESS';
export const F2F_STATUS_FETCH_ERROR = 'F2F_STATUS_FETCH_ERROR';
export const f2fStatusFetch = () => ({type: F2F_STATUS_FETCH});

export const F2F_LANGUAGES_FETCH = 'F2F_LANGUAGES_FETCH';
export const F2F_LANGUAGES_FETCH_SUCCESS = 'F2F_LANGUAGES_FETCH_SUCCESS';
export const F2F_LANGUAGES_FETCH_ERROR = 'F2F_LANGUAGES_FETCH_ERROR';
export const f2fLanguagesFetch = () => ({type: F2F_LANGUAGES_FETCH});

export const F2F_LOCATIONS_FETCH = 'F2F_LOCATIONS_FETCH';
export const F2F_LOCATIONS_FETCH_SUCCESS = 'F2F_LOCATIONS_FETCH_SUCCESS';
export const F2F_LOCATIONS_FETCH_ERROR = 'F2F_LOCATIONS_FETCH_ERROR';
export const f2fLocationsFetch = () => ({type: F2F_LOCATIONS_FETCH});

export const F2F_SCHOOLS_FETCH = 'F2F_SCHOOLS_FETCH';
export const F2F_SCHOOLS_FETCH_SUCCESS = 'F2F_SCHOOLS_FETCH_SUCCESS';
export const F2F_SCHOOLS_FETCH_ERROR = 'F2F_SCHOOLS_FETCH_ERROR';
export const f2fSchoolsFetch = () => ({type: F2F_SCHOOLS_FETCH});

export const F2F_REFERRAL_CREATE = 'F2F_REFERRAL_CREATE';
export const F2F_REFERRAL_CREATE_SUCCESS = 'F2F_REFERRAL_CREATE_SUCCESS';
export const F2F_REFERRAL_CREATE_ERROR = 'F2F_REFERRAL_CREATE_ERROR';
export const f2fReferralCreate = (data, resolve, reject, successMessage) => ({type: F2F_REFERRAL_CREATE, data, resolve, reject, successMessage});

export const F2F_FIELD_VALIDATE = 'F2F_FIELD_VALIDATE';
export const F2F_FIELD_VALIDATE_SUCCESS = 'F2F_FIELD_VALIDATE_SUCCESS';
export const F2F_FIELD_VALIDATE_ERROR = 'F2F_FIELD_VALIDATE_ERROR';
export const f2fFieldValidate = (field, value, resolve, reject) => ({type: F2F_FIELD_VALIDATE, field, value, resolve, reject});




/** WEBPACK FOOTER **
 ** ./src/members/state/f2f/actions.js
 **/